import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dismiss() {
    this.element.classList.add("is-dismissed")
    setTimeout(() => this.hideButton(), 250)
  }

  hideButton() {
    this.element.classList.add("is-hidden")
  }
}